import { DatasetGridColumn } from '../../../../services/dataset/view-model/DatasetGridColumn';

export const getOrderedColumns = (
  columnsOrder: string[],
  columns: DatasetGridColumn[]
): DatasetGridColumn[] =>
  columnsOrder.reduce<DatasetGridColumn[]>((ordered, field) => {
    const foundColumn = columns.find(column => column.field === field);
    if (foundColumn) {
      ordered.push(foundColumn);
    }
    return ordered;
  }, []);
